import Svg, { type SvgProps } from '../../Svg';

const CopyIcon = (props: SvgProps) => (
  <Svg width={12} height={12} {...props}>
    <g clipPath="url(#clip0_555_4670)">
      <path
        d="M8.75002 11.5H2.15002C1.95553 11.5 1.769 11.4227 1.63148 11.2852C1.49395 11.1477 1.41669 10.9612 1.41669 10.7667V2.88333"
        className="stroke-current"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5834 9.01107C10.5887 9.24373 10.5017 9.46906 10.3414 9.63773C10.1811 9.80641 9.96044 9.90471 9.7278 9.91111H3.73891C3.50627 9.90471 3.28564 9.80641 3.1253 9.63773C2.96496 9.46906 2.87796 9.24373 2.88335 9.01107V1.40004C2.87796 1.16738 2.96496 0.942055 3.1253 0.773376C3.28564 0.604698 3.50627 0.506402 3.73891 0.5H8.09002C8.2035 0.50057 8.31568 0.524225 8.41974 0.569527C8.52379 0.614829 8.61753 0.680829 8.69527 0.763511L10.3326 2.48636C10.4944 2.65833 10.5841 2.88578 10.5834 3.12191V9.01107Z"
        className="stroke-current"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_555_4670">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);

export default CopyIcon;
